module.exports = __webpack_public_path__ + "img/aej1n-66wvl.026.ceaac5e6.png";